export var getBrowserCookie = function (name) {
    try {
        var result_1 = {};
        document.cookie.split(';').forEach(function (el) {
            var _a = el.split('='), name = _a[0], value = _a[1];
            result_1[name.trim()] = value.trim();
        });
        return result_1[name];
    }
    catch (_a) {
        return '';
    }
};
